import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs/Observable';

import { CookieService } from 'app/services/cookie.service';
import { ObservableRequestService } from 'app/services/observable-request.service';
import { ConstantsService } from 'app/services/constants-service';

import { Http, Response, Headers, RequestOptions } from '@angular/http';

@Injectable()
export class LegalStructureService {
    // As our URL is accessed through IFrame which is an external content for
    // angular application. So, we need to bypass security trust check using
    // DOM Sanitizer in order to display content for our URL.
    constructor(
        private observableRequest: ObservableRequestService,
        private domSanitizer: DomSanitizer,
        private cookieService: CookieService,
        private http: Http,
    ) { }

    // Method to fetch Legal Structure Search results.
    getLegalStructureSearchResults(): Observable<any> {
        let legalStructureUri = ConstantsService.LEGAL_STRUCTURE_URL;
        return this.observableRequest.getRequest(legalStructureUri);
    }

    // Service Method to add new requested Legal Structure value to database.
    // @todo Right now Warm-up service is creating problem in returning results,
    // so need to make changes once that works fine.
    addLegalStructure(newLegalStructureValue: string, legalStructureAppTypeConst: string): Observable<any> {
        let postBody = {
            'type': legalStructureAppTypeConst,
            'value': newLegalStructureValue
        };
        const addLegalStructureUrl = ConstantsService.ADD_APPLICATION_TYPE_URL;
        return this.observableRequest
            .postRequest(addLegalStructureUrl,
            postBody,
            this.observableRequest.getJSONContentType());
    };
}



// WEBPACK FOOTER //
// ./src/app/shared/components/legalstructure/legal-structure.service.ts